import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Branding/Logo';

function OnboardingAdminScreen() {
  return (
    <div className="col-md-6 form-side">
      <div className="form-container text-center">
        <Logo />
        <h1 className="text-success fw-bold mb-4">Portal de Administración</h1>
        <h4 className="mb-5">Acceso para administradores del sistema Checkin.</h4>
        <p>Por favor, inicie sesión para acceder a las herramientas de gestión y configuración.</p>
        <div className="buttons-container d-grid gap-3 mt-5 mb-5">
          {/* This link will go to /login, which will then render LoginAdminScreen due to REACT_APP_LOGIN_TYPE=admin */}
          <Link to="/login" className="btn btn-checkin" role="button">Iniciar Sesión como Administrador</Link>
        </div>
        <p className="mt-3 text-muted small">Plataforma Checkin © 2024</p>
      </div>
    </div>
  );
}
export default OnboardingAdminScreen;